export enum enumEntityType {
  buyer = 1,
  seller = 2,
}
